import {DateTime} from 'luxon';

export enum PlanningEventType {
  STUDENT_ABSENCE = 'STUDENT_ABSENCE',
  PERSONAL_NOTE = 'PERSONAL_NOTE',
  SCHOOL_DIARY = 'SCHOOL_DIARY',
  RESOURCE_RESERVATION = 'RESOURCE_RESERVATION'
}

export interface TeacherPlanningEvent {
  id?: string;
  type: PlanningEventType;
  date: DateTime;
  hour?: string;
}

export interface TeacherPlanningPersonalNoteEvent extends TeacherPlanningEvent {
  note?: string;
}

export interface StudentAbsenceEvent extends TeacherPlanningEvent {
  firstName?: string;
  lastName?: string;
}

export interface SchoolDiaryEntryEvent extends TeacherPlanningEvent {
  attributionId?: number;
  attributionPseudo?: string;
  lessonSubject?: string;
  homework?: string;
  homeworkDone?: boolean;
  homeworkCreationDate?: DateTime;
  homeworkUpdateDate?: DateTime;
  remark?: string;
  lessonName?: string;
  lessonHours?: number;
  teacherFirstName?: string;
  teacherLastName?: string;
}

export interface ResourceReservationEvent extends TeacherPlanningEvent {
  reference?: string;
}
